import styled from 'styled-components'

const TaskStyled = styled.div`
  padding: 20px;
  border-bottom: 1px solid #ccc;
  margin: 0;
  transition: 200ms;

  &:hover {
    background: hsla(45, 86%, 62%, 0.2);
  }
`

export default TaskStyled



// WEBPACK FOOTER //
// ./src/Task/TaskStyled/index.js